import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage from "./pages/Home/HomePage";
import PhotoUploadPage from "./pages/PhotoUpload/PhotoUploadPage";
import CollageEditor from "./pages/CollageEditor/CollageEditor";

import FramesEditor from "./pages/FramesEditor/FramesEditor";
import MarcoDuo from "./pages/MarcoDuo/MarcoDuo";
import MarcoMosaico from "./pages/MarcoMosaico/MarcoMosaico";
import MarcoSecuencia from "./pages/MarcoSecuencia/MarcoSecuencia";
import ProductPage from "./pages/ProductPage/ProductPage";
import CartPage from "./pages/Cart/CartPage";

import SuccessPage from "./pages/Checkout/SuccessPage";
import CancelPage from "./pages/Checkout/CancelPage";

import TermsPage from "./pages/legal/TermsPage";
import PrivacyPage from "./pages/legal/PrivacyPage";
import RefundsPage from "./pages/legal/RefundsPage";
import ContactPage from "./pages/Contact/ContactPage";
import HelpPage from "./pages/HelpPage/HelpPage";
import OffersPage from "./pages/Offers/OffersPage";
import WhatsAppButton from "./components/WhatsAppButton";
import CookieBanner from "./components/CookieBanner";

import ScrollToTop from "./components/ScrollToTop";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route path="/producto/:slug" element={<ProductPage />} />

          <Route path="/carrito" element={<CartPage />} />

          <Route path="/editor" element={<CollageEditor />} />

          <Route path="/fotos" element={<PhotoUploadPage />} />

          <Route path="/marcos" element={<FramesEditor />} />

          <Route path="/marcos-individuales" element={<FramesEditor />} />

          <Route path="/marco-duo" element={<MarcoDuo />} />

          <Route path="/marco-mosaico" element={<MarcoMosaico />} />

          <Route path="/marco-secuencia" element={<MarcoSecuencia />} />

          <Route path="/terminos" element={<TermsPage />} />

          <Route path="/privacidad" element={<PrivacyPage />} />

          <Route path="/devoluciones" element={<RefundsPage />} />

          <Route path="/contacto" element={<ContactPage />} />

          <Route path="/ayuda" element={<HelpPage />} />


          <Route path="/ofertas" element={<OffersPage />} />

          <Route path="/success" element={<SuccessPage />} />

          <Route path="/cancel" element={<CancelPage />} />
        </Routes>

        <WhatsAppButton />

        <CookieBanner />
      </>
    </BrowserRouter>
  );
}
